import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import shapeTypes from '../../constants/ShapeConstants';
import configuration from '../../constants/Configuration';
import { Background } from './shapes/Background';
import { Character } from './shapes/Character';
import { Image } from './shapes/Image';
import { Rectangle } from './shapes/Rectangle';
import { Triangle } from './shapes/Triangle';
import { Star } from './shapes/Star';
import { Heart } from './shapes/Heart';
import { Ellipse } from './shapes/Ellipse';
import { Line } from './shapes/Line';
import { Curve } from './shapes/Curve';
import { Freehand } from './shapes/Freehand';
import { TextBox } from './shapes/TextBox';
import { TextBoxSimple } from './shapes/TextBoxSimple';
import { SpeakBubble } from './shapes/SpeakBubble';
import { ThoughtBubble } from './shapes/ThoughtBubble';
import { ScreamBubble } from './shapes/ScreamBubble';
import { TextBoxRich } from './shapes/TextBoxRich';
import { TextBoxSimpleRich } from './shapes/TextBoxSimpleRich';
import { SpeakBubbleRich } from './shapes/SpeakBubbleRich';
import { ThoughtBubbleRich } from './shapes/ThoughtBubbleRich';
import { ScreamBubbleRich } from './shapes/ScreamBubbleRich';
import { ComplexSpeakBubbleRich } from './shapes/ComplexSpeakBubbleRich';
import { Video } from './shapes/Video';
import { Group } from './shapes/Group';
import { ZoomTransformTool } from './interactive/ZoomTransformTool';
import { CroppingTransformTool } from './interactive/CroppingTransformTool';
import appParameters from '../utils/AppParameters';
import selectionManager from '../utils/SelectionManager';
import modeType from '../../constants/ModeConstants';
import animationManager from '../utils/AnimationManager';
import { ComplexSpeakBubble } from './shapes/ComplexSpeakBubble';
import localesManager from "../../locales/LocalesManager";

const SVGContainerContent = React.createClass({
    propTypes: {
        dispatch: React.PropTypes.func.isRequired,
        slideModel: React.PropTypes.object.isRequired
    },
    getShape(shape) {
        const { dispatch } = this.props;

        switch(shape.type) {
            case shapeTypes.BACKGROUND:
                return <Background shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} showZoomSlides={this.props.showZoomSlides} key={shape.uuid}/>;

            case shapeTypes.CHARACTER:
                return <Character shapeModel={shape} dispatch={dispatch} showCroppingMenu={this.props.showCroppingMenu} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.IMAGE:
                return <Image shapeModel={shape} dispatch={dispatch} showCroppingMenu={this.props.showCroppingMenu} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.RECTANGLE:
                return <Rectangle shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.TRIANGLE:
                return <Triangle shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.STAR:
                return <Star shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.HEART:
                return <Heart shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.ELLIPSE:
                return <Ellipse shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.LINE:
                return <Line shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.CURVE:
                return <Curve shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.FREEHAND:
                return <Freehand shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;

            case shapeTypes.GROUP: {
                return <Group shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }

            case shapeTypes.VIDEO: {
                return <Video shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }

            case shapeTypes.TEXTBOX: {
                if (shape.isRichText)
                    return <TextBoxRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                else
                    return <TextBox shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }

            case shapeTypes.TEXTBOXSIMPLE: {
                if (shape.isRichText)
                    return <TextBoxSimpleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                else
                    return <TextBoxSimple shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }

            case shapeTypes.SPEAK_BUBBLE: {
                if (shape.isRichText)
                    return <SpeakBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                else
                    return <SpeakBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }

            case shapeTypes.COMPLEX_SPEAK_BUBBLE: {
                if (shape.isRichText)
                    return <ComplexSpeakBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                else
                    return <ComplexSpeakBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }

            case shapeTypes.THOUGHT_BUBBLE: {
                if (shape.isRichText)
                    return <ThoughtBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                else
                    return <ThoughtBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }

            case shapeTypes.SCREAM_BUBBLE: {
                if (shape.isRichText)
                    return <ScreamBubbleRich shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
                else
                    return <ScreamBubble shapeModel={shape} dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={shape.uuid}/>;
            }
        }
    },
    render() {
        var videos = [];
        const { dispatch } = this.props;

        var slideModel;

        if (this.props.slideModelPrint)
            slideModel = this.props.slideModelPrint;
        else
            slideModel = this.props.slideModel;

        var shapes = [];

        if (slideModel && slideModel.content) {
            shapes = slideModel.content.map((shape) => {
                return this.getShape(shape);
            });
        }

        if (appParameters.context != modeType.PLAYER && appParameters.context != modeType.PRINT) {
            shapes.push(<ZoomTransformTool dispatch={dispatch} scaleProperties={this.props.scaleProperties} backgroundModel={slideModel.content[0]} key={'ZoomTransformTool_' + slideModel.content[0].uuid}/>);
            shapes.push(<CroppingTransformTool dispatch={dispatch} scaleProperties={this.props.scaleProperties} key={'CroppingTransformTool'}/>);
        }
        var viewBox = '0 0 ' + configuration.CANVAS_WIDTH + ' ' + configuration.CANVAS_HEIGHT;

        let animationElements = [];

        if (animationManager.isAnimationMode() && animationManager.clone) {
            let clones= animationManager.getAllAnimationTargets();

            for (let i=0; i<clones.length - 1; i++) {
                let target = clones[i];
                let clone = clones[i+1];
                let animationClone = this.getShape(clone);
                let line;
                let animationElement;

                if (!target.isInteraction && !clone.isInteraction)
                    line = animationManager.getLine(target, clone, i, clones.length);

                animationElement =
                    <g x="0.00" y="0.00" width={configuration.CANVAS_WIDTH} height={configuration.CANVAS_WIDTH} key={'animationElement_' + i}>
                        {animationClone}
                        {line}
                    </g>;

                animationElements.push(animationElement);
            }
        }

        return (
            <svg id='canvas' role='img' aria-label={localesManager.getCaption('canvas', 'other')} width={configuration.CANVAS_WIDTH} height={configuration.CANVAS_HEIGHT} viewBox={viewBox}>
                <defs>
                    <filter id="2" width="150%" height="150%">
                        <feOffset result="offOut" in="SourceAlpha" dx="4" dy="4"/>
                        <feGaussianBlur result="blurOut" in="offOut" stdDeviation="4"/>
                        <feBlend in="SourceGraphic" in2="blurOut" mode="normal"/>
                    </filter>
                    <filter id="5" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%">
                        <feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 1 1 1 0"/>
                    </filter>
                </defs>
                {shapes}
                {animationElements}
            </svg>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    const slideModel = state.currentSlide.model;
    var showCroppingMenu = state.menu.showCroppingMenu;
    var showZoomSlides = state.menu.showZoomSlides;
    var updateSlide = state.menu.updateSlide;

    if (showZoomSlides == undefined)
        showZoomSlides = false;

    if (showCroppingMenu == undefined)
        showCroppingMenu = false;

    return {
        slideModel,
        showZoomSlides,
        showCroppingMenu,
        updateSlide
    };
}

export const SVGContainer = connect(mapStateToProps)(SVGContainerContent);



/** WEBPACK FOOTER **
 ** ./src/components/slide/SVGContainer.js
 **/